import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { CYLINDO_OPTIONS, CYLINDO_ACCOUNT_ID, FABRIC_PRODUCT_OPTION_ID, LEATHER_PRODUCT_OPTION_ID } from 'commons/constants';
import { orientationOptionIds } from 'components/consumer/OrientationPDPModal';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useCylindoDimensionShots from '../useCylindoDimensionShots';
import useCylindoCache from './cylindoCache/useCylindoCache';
import resolveCylindoUpholsteryCode from './resolveCylindoUpholsteryCode';
import { DISABLED_UPHOLSTERY, EMPTY_ARRAY, EMPTY_OBJECT, CYLINDO_FRAMES_TO_SHOW, CYLINDO_CONTENT_API } from './cylindoCache/defaults';
const usePDPCylindoViewer = t0 => {
  const $ = _c(35);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isPDPDesktop: t2,
    material: t3,
    deferCylindoFetch: t4
  } = t1;
  const isPDPDesktop = t2 === undefined ? false : t2;
  const material = t3 === undefined ? null : t3;
  const deferCylindoFetch = t4 === undefined ? false : t4;
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    data: t5
  } = usePDPOptions();
  const {
    selectedOptionsExtended
  } = t5;
  const productId = basicDetails?.id;
  const isCylindoProduct = !!basicDetails?.custom_properties?.cylindo_product;
  const {
    config: cylindoProductConfig,
    version: cylindoVersion,
    loading
  } = useCylindoCache(productId, isCylindoProduct, deferCylindoFetch);
  material?.label;
  let t6;
  bb0: {
    if (!productId || !cylindoProductConfig || !selectedOptionsExtended) {
      t6 = null;
      break bb0;
    }
    const fabricOption = selectedOptionsExtended[FABRIC_PRODUCT_OPTION_ID]?.value;
    const leatherOption = selectedOptionsExtended[LEATHER_PRODUCT_OPTION_ID]?.value;
    const selectedOption = fabricOption || leatherOption || null;
    const jbName = material?.label ?? selectedOption?.value ?? null;
    const jbSku = selectedOption?.sku ?? null;
    if (!jbName) {
      t6 = null;
      break bb0;
    }
    let resolved;
    let t7;
    if ($[2] !== cylindoProductConfig.features || $[3] !== jbName || $[4] !== jbSku) {
      const upholsteryFeature = cylindoProductConfig.features?.find(_temp);
      resolved = resolveCylindoUpholsteryCode({
        jbSku,
        jbName,
        cylindoOptions: upholsteryFeature?.options
      });
      t7 = resolved && DISABLED_UPHOLSTERY.includes(resolved);
      $[2] = cylindoProductConfig.features;
      $[3] = jbName;
      $[4] = jbSku;
      $[5] = resolved;
      $[6] = t7;
    } else {
      resolved = $[5];
      t7 = $[6];
    }
    if (t7) {
      t6 = null;
      break bb0;
    }
    t6 = resolved;
  }
  const upholsteryKey = t6;
  const hasUpholsteryOption = !!upholsteryKey;
  let t7;
  if ($[7] !== cylindoVersion || $[8] !== upholsteryKey) {
    t7 = {
      upholsteryKey,
      cylindoVersion
    };
    $[7] = cylindoVersion;
    $[8] = upholsteryKey;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const dimensionShotsData = useCylindoDimensionShots(t7);
  let t8;
  bb1: {
    if (!upholsteryKey) {
      t8 = undefined;
      break bb1;
    }
    let t9;
    if ($[10] !== upholsteryKey) {
      t9 = {
        [CYLINDO_OPTIONS.UPHOLSTERY]: upholsteryKey
      };
      $[10] = upholsteryKey;
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    t8 = t9;
  }
  const upholsteryFeatureDetails = t8;
  const isUpholsteryFeatureAvailable = !!upholsteryFeatureDetails;
  const orientationId = orientationOptionIds.find(id => selectedOptionsExtended[id]);
  const orientationValue = selectedOptionsExtended[orientationId]?.value?.value;
  let t9;
  if ($[12] !== orientationValue) {
    t9 = orientationValue?.toUpperCase();
    $[12] = orientationValue;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const orientationKey = t9;
  const hasOrientationOption = !!orientationKey;
  let t10;
  if ($[14] !== cylindoProductConfig?.features || $[15] !== orientationKey) {
    t10 = () => {
      if (!orientationKey) {
        return;
      }
      const orientationFeature = cylindoProductConfig?.features?.find(_temp2);
      const orientationKeyStr = String(orientationKey).trim().toLowerCase();
      const orientationOption = orientationFeature?.options?.find(opt => String(opt.code).trim().toLowerCase() === orientationKeyStr);
      if (!orientationOption) {
        return;
      }
      return {
        [CYLINDO_OPTIONS.ORIENTATION]: orientationOption.code
      };
    };
    $[14] = cylindoProductConfig?.features;
    $[15] = orientationKey;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  cylindoProductConfig?.features;
  let t11;
  if ($[17] !== t10) {
    t11 = t10();
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const orientationOptionDetails = t11;
  const isOrientationFeatureAvailable = !!orientationOptionDetails;
  const areAllFeaturesAvailable = (!hasUpholsteryOption || hasUpholsteryOption && isUpholsteryFeatureAvailable) && (!hasOrientationOption || hasOrientationOption && isOrientationFeatureAvailable);
  let t12;
  bb2: {
    if (!upholsteryFeatureDetails && !orientationOptionDetails) {
      t12 = EMPTY_OBJECT;
      break bb2;
    }
    const t13 = upholsteryFeatureDetails || EMPTY_OBJECT;
    const t14 = orientationOptionDetails || EMPTY_OBJECT;
    let t15;
    if ($[19] !== t13 || $[20] !== t14) {
      t15 = {
        ...t13,
        ...t14
      };
      $[19] = t13;
      $[20] = t14;
      $[21] = t15;
    } else {
      t15 = $[21];
    }
    t12 = t15;
  }
  const cylindoFeatures = t12;
  let t13;
  bb3: {
    if (isPDPDesktop && areAllFeaturesAvailable && Object.entries(cylindoFeatures).length) {
      let t14;
      if ($[22] !== cylindoFeatures) {
        t14 = Object.entries(cylindoFeatures).map(_temp3);
        $[22] = cylindoFeatures;
        $[23] = t14;
      } else {
        t14 = $[23];
      }
      const featuresString = t14.join("&feature=");
      let t15;
      if ($[24] !== featuresString || $[25] !== productId) {
        t15 = CYLINDO_FRAMES_TO_SHOW.map((frame, index) => ({
          id: frame,
          index,
          src: `${CYLINDO_CONTENT_API}/${CYLINDO_ACCOUNT_ID}/products/${productId}/frames/${frame}?feature=${featuresString}`,
          type: "cylindo"
        }));
        $[24] = featuresString;
        $[25] = productId;
        $[26] = t15;
      } else {
        t15 = $[26];
      }
      t13 = t15;
      break bb3;
    }
    t13 = EMPTY_ARRAY;
  }
  const cylindoConfigurationPhotos = t13;
  const t14 = !!cylindoProductConfig && areAllFeaturesAvailable;
  const t15 = isCylindoProduct && !!cylindoProductConfig && areAllFeaturesAvailable && cylindoConfigurationPhotos?.length > 0;
  let t16;
  if ($[27] !== cylindoConfigurationPhotos || $[28] !== cylindoFeatures || $[29] !== dimensionShotsData || $[30] !== loading || $[31] !== t14 || $[32] !== t15 || $[33] !== upholsteryKey) {
    t16 = {
      cylindoConfigurationPhotos,
      cylindoFeatures,
      isCylindoAvailable: t14,
      loading,
      isCylindoConfigurationPhotos: t15,
      upholsteryKey,
      ...dimensionShotsData
    };
    $[27] = cylindoConfigurationPhotos;
    $[28] = cylindoFeatures;
    $[29] = dimensionShotsData;
    $[30] = loading;
    $[31] = t14;
    $[32] = t15;
    $[33] = upholsteryKey;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
};
export default usePDPCylindoViewer;
function _temp(feat) {
  return feat.code === CYLINDO_OPTIONS.UPHOLSTERY;
}
function _temp2(feat_0) {
  return feat_0.code === CYLINDO_OPTIONS.ORIENTATION;
}
function _temp3(t0) {
  const [featureKey, featureCode] = t0;
  return `${featureKey}:${featureCode}`;
}